export default "/images/download.svg";